import HelpdeskGraphQL from "./HelpdeskGraphQL";
import axios from "./Axios";

class Lead extends HelpdeskGraphQL {

    static async updateProperties(id, properties, { appClientId, doIdResolution = true }) {
        return await axios()({
            url: this.url + '/update_lead/' + id,
            method: 'POST',
            responseType: 'json',
            data: {
                properties,
                doIdResolution,
                appClientId,
            }
        })
    }
}

export default Lead;